/**
 * bopi bopi — shared cart helper.
 *
 * Uses Shopify's Standard Storefront Actions API (Shopify.actions.updateCart /
 * openCart), released Spring '26, so adding to cart from these custom
 * sections plugs into Horizon's real cart drawer and cart-count bubble —
 * the same as any native Horizon "Add to cart" button.
 *
 * Falls back to the classic /cart/add.js Ajax API on any theme that doesn't
 * expose Shopify.actions yet, so these sections keep working either way.
 */
(function () {
  'use strict';

  /**
   * @param {object} opts
   * @param {string} opts.variantId   Numeric variant id (e.g. "42165423636542")
   * @param {number} opts.quantity
   * @param {Record<string,string>} [opts.attributes]  Line item properties
   * @param {boolean} [opts.openCart] Open the cart drawer on success (skip for checkout flows)
   * @returns {Promise<{ok: boolean, itemCount?: number}>}
   */
  function addToCart(opts) {
    var variantId = opts.variantId;
    var quantity = opts.quantity || 1;
    var attributes = opts.attributes || null;
    var shouldOpenCart = opts.openCart !== false;

    var actions = window.Shopify && window.Shopify.actions;

    if (actions && typeof actions.updateCart === 'function') {
      var lines = [{
        merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
        quantity: quantity
      }];
      if (attributes) {
        lines[0].attributes = Object.keys(attributes).map(function (key) {
          return { key: key, value: attributes[key] };
        });
      }

      return actions.updateCart({ lines: lines }).then(function (result) {
        if (result && result.userErrors && result.userErrors.length) {
          return { ok: false };
        }
        if (shouldOpenCart && typeof actions.openCart === 'function') {
          actions.openCart();
        }
        var itemCount = result && result.cart && (result.cart.totalQuantity ?? result.cart.item_count);
        return { ok: true, itemCount: itemCount };
      }).catch(function () {
        return addToCartLegacy(variantId, quantity, attributes);
      });
    }

    return addToCartLegacy(variantId, quantity, attributes);
  }

  function addToCartLegacy(variantId, quantity, attributes) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity, properties: attributes || undefined }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return { ok: true, itemCount: cart.item_count };
      })
      .catch(function () {
        return { ok: false };
      });
  }

  window.BopiCart = { addToCart: addToCart };

  // Auto-wire any [data-add-to-cart][data-variant-id] button on the page
  // (used by the Designs Grid's "+ Add to pouch" buttons and the sticky buy bar).
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      if (button.dataset.bopiWired) return;
      button.dataset.bopiWired = 'true';

      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;
        var quantity = parseInt(button.getAttribute('data-quantity'), 10) || 2;

        var original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';

        addToCart({ variantId: variantId, quantity: quantity }).then(function (result) {
          button.textContent = result.ok ? 'Added!' : 'Try again';
          setTimeout(function () {
            button.textContent = original;
            button.disabled = false;
          }, 1200);
        });
      });
    });
  });
})();
